import Logger from "../core/util/Logger";

export const popupDisplayHandlerAction = (payload) => async dispatch => {
    Logger.info("popup display handler [" + payload.id + "] [" + payload.shouldDisplay + "] ");
    dispatch({type: "POPUP_HANDLER", payload: payload});
};